import { createContext, useContext } from "react";

const defaultContextValue = {
  showModal: false,
  setShowModal: () => { },
  // Data
  units: [],
  subUnitsMap: {},
  // Methods
  getSubUnits: (unitId) => { },
  // Modals
  onGenerateModal: () => { },
  onGenerateQuizModal: () => { },
};

export const MasteryMapContext = createContext(defaultContextValue);

// Hook to use the context
export const useMasteryMap = () => {
  const context = useContext(MasteryMapContext);
  if (!context) {
    throw new Error("useMasteryMap must be used within a MasteryMapProvider");
  }
  return context;
}

const defaultMapContextValue = {
  onDeepDive: () => { },
  onPractice: () => { },
}

export const MapContext = createContext(defaultMapContextValue);

export const useMapContext = () => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error("useMap must be used within a MapProvider");
  }

  return context;
}
